import React from "react";
import Chart from "react-apexcharts";
import "../../styles/all.css"
import "../../styles/theme.css"

export default function VisitorHeatmap() {
  const series = [
    {
      name: "Visitors",
      data: [80, 50, 30, 40, 100, 20],
    },
  ];

  const options = {
    chart: {
      type: "radar",
      toolbar: { show: false },
    },
    xaxis: {
      categories: [
        "Home",
        "Products",
        "Services",
        "Blog",
        "About",
        "Contact",
      ],
    },
    stroke: {
      width: 2,
    },
    fill: {
      opacity: 0.3,
    },
    markers: {
      size: 4,
    },
    colors: ["#6366f1"],
    title: {
      text: "Visitor Overview",
      style: {
        fontSize: "16px",
      },
    },
  };

  return (
    <div
      style={{
  background: "var(--colortext)",
  padding: "20px",
  borderRadius: "12px",
  boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
}}

    >
      <Chart options={options} series={series} type="radar" height={350} />
    </div>
  );
}
